module.exports = __webpack_public_path__ + "ng.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ng.svg
// module id = 730
// module chunks = 0